import { useState } from "react";
import { TAssignedCoursesTableType, TTableColumn } from "../../types";
import { RowsPerPageEnum } from "../../displayColumnsConfig";
import CustomTableMaterial from "../../shared/table/customTableMaterial";
import { Link } from "react-router-dom";
import { useAuthContext } from "../../context/authContext";
import { IconButton } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import PersonIcon from "@mui/icons-material/Person";
import { isNoRoles } from "../../helpers/role";
import { InfoService } from "../../APIService/InfoService";

export const ZeroesToDashes = (s: string, row?: any): JSX.Element => {
  let stringValue = s?.toString() || "";
  if (stringValue === "0") {
    stringValue = "-";
  }
  return <span>{stringValue}</span>;
};

function LearningTable(props: {
  userId: any;
  tableData: TAssignedCoursesTableType[];
  expandableRow: boolean;
  expandedRowContent: (row: any) => JSX.Element;
  refreshData: () => void;
}) {
  const [page] = useState(0);
  const [rowsPerPage] = useState(RowsPerPageEnum.ALL);
  const { authInfo } = useAuthContext();

  let learningColumns: TTableColumn[] = [
    {
      id: "course_id",
      label: "Курс",
      minWidth: 50,
      align: "left",
      linkTo: "/course/",
    },
    {
      // this column will be deleted for non-priviledged users
      id: "assigned_by_user",
      label: <PersonIcon />,
      minWidth: 50,
      align: "left",
      tooltip: "Добавлен пользователем",
      format: (value: string, row: any) =>
        row.assigner_id == props.userId ? <HowToRegIcon /> : <></>,
    },
    {
      // this column will be deleted for priviledged users
      id: "assigner_id",
      label: <DeleteForeverIcon />,
      minWidth: 50,
      align: "left",
      tooltip: "Удалить этот курс",
      format: (value: string, row: any) =>
        row.assigner_id == authInfo.id ? (
          <IconButton
            aria-label="delete"
            size="small"
            style={{ color: "red" }}
            onClick={async () => {
              await InfoService.deleteCourse(authInfo.id, row.course_id);
              props.refreshData();
            }}
          >
            <DeleteForeverIcon />
          </IconButton>
        ) : (
          <></>
        ),
      stylef: (value: string) => ({
        paddingLeft: "11px",
        textColor: "red",
      }),
    },
    {
      id: "site_name",
      label: "Название",
      minWidth: 50,
      align: "left",
      format: (value: string, row: any) => {
        return (
          <Link
            style={{ color: "blue", textDecoration: "none" }}
            to={`/course/${row.id}`}
          >
            {value}
          </Link>
        );
      },
      stylef: (value: string) => ({
        color: "blue",
        textDecoration: "none",
      }),
    },
    {
      id: "correct_cnt",
      label: "Верно 1 попытка",
      minWidth: 40,
      align: "left",
      format: ZeroesToDashes,
    },
    {
      id: "wrongcorrect_cnt",
      label: "Верно ≥ 2 попыток",
      minWidth: 50,
      maxWidth: 150,
      align: "left",
      format: ZeroesToDashes,
    },
    {
      id: "wrong_cnt",
      label: "Неверно",
      minWidth: 50,
      align: "left",
      format: ZeroesToDashes,
    },
    {
      id: "no_answer_cnt",
      label: "Нет ответов",
      minWidth: 40,
      align: "left",
    },
    {
      id: "course_task_cnt",
      label: "Всего",
      minWidth: 40,
      align: "left",
    },
    {
      id: "publish_date",
      label: "Дата",
      minWidth: 100,
      align: "left",
    },
  ];

  if (!isNoRoles(authInfo.role)) {
    learningColumns = learningColumns.filter((c) => c.id != "assigner_id");
  } else {
    learningColumns = learningColumns.filter((c) => c.id != "assigned_by_user");
  }

  return (
    <div>
      <CustomTableMaterial<TAssignedCoursesTableType>
        list={props.tableData as TAssignedCoursesTableType[]}
        page={page}
        columns={learningColumns}
        localPagination={true}
        rowsPerPage={rowsPerPage}
        expandableRow={props.expandableRow}
        expandedRowFormat={props.expandedRowContent}
      />
    </div>
  );
}

export default LearningTable;
